import { useTranslation } from 'react-i18next';
import { Badge, Card, Group, List, SimpleGrid, Stack, Text, ThemeIcon } from '@mantine/core';
import { IconCheck, IconTruck } from '@tabler/icons-react';

// Этапы сделки в порядке процесса. Перевозка — текущий этап условного примера.
const STAGES = ['attestation', 'dates', 'spec', 'invoices', 'assignment', 'transport', 'settlement', 'documents'] as const;
const CURRENT = STAGES.indexOf('transport');

function StageIcon({ index }: { readonly index: number }) {
  if (index < CURRENT) {
    return (
      <ThemeIcon color="lime.4" c="brand.9" size={24} radius="xl">
        <IconCheck size={14} />
      </ThemeIcon>
    );
  }
  if (index === CURRENT) {
    return (
      <ThemeIcon color="brand.7" size={24} radius="xl">
        <IconTruck size={14} />
      </ThemeIcon>
    );
  }
  return <ThemeIcon variant="light" color="gray" size={24} radius="xl" />;
}

// Условный экран сделки: показывает обещание продукта — обе стороны видят свои деньги и ход сделки. Числа и сделка
// вымышлены и помечены как пример, настоящих данных здесь нет.
export default function DealExample() {
  const { t } = useTranslation();
  const base = 'landing.how.example';

  return (
    <Card withBorder radius={0} padding="lg" bg="white">
      <Stack gap="md">
        <Group justify="space-between" wrap="nowrap" align="flex-start">
          <Text fw={700}>{t(`${base}.goods`)}</Text>
          <Badge variant="light" color="gray" tt="none" fw={500} style={{ flexShrink: 0 }}>
            {t(`${base}.badge`)}
          </Badge>
        </Group>

        <SimpleGrid cols={{ base: 1, xs: 2 }} spacing="sm">
          <Stack gap={2}>
            <Text size="sm" c="gray.7">
              {t(`${base}.sellerLabel`)}
            </Text>
            <Text fz={24} fw={700} c="brand.9" lh={1.2}>
              {t(`${base}.sellerPrice`)}
            </Text>
          </Stack>
          <Stack gap={2}>
            <Text size="sm" c="gray.7">
              {t(`${base}.buyerLabel`)}
            </Text>
            <Text fz={24} fw={700} c="brand.9" lh={1.2}>
              {t(`${base}.buyerPrice`)}
            </Text>
          </Stack>
        </SimpleGrid>

        <List spacing="xs" center listStyleType="none">
          {STAGES.map((stage, index) => (
            <List.Item key={stage} icon={<StageIcon index={index} />}>
              <Text size="sm" fw={index === CURRENT ? 700 : 400} c={index > CURRENT ? 'gray.7' : undefined}>
                {t(`landing.how.stages.${stage}`)}
                {index === CURRENT ? ` — ${t(`${base}.transportStatus`)}` : ''}
              </Text>
            </List.Item>
          ))}
        </List>
      </Stack>
    </Card>
  );
}
